module.exports = __webpack_public_path__ + "static/24-8ba60ed9e70c7b5bc97b1e32a0e1a3c0.jpg";